import React, { useEffect } from 'react';
import "./App.css";
import "antd/dist/antd.css";
import "./components/landing/ssddservices.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "components/landing/Landing";
import ApplicationForm from "components/applicationform/ApplicationForm";
import ErrorBoundary from "components/shared/ErrorBoundary";
import { ErrorProvider, useError } from "components/shared/ErrorContext";
import GlobalErrorModal from "components/shared/GlobalErrorModal";
import { setGlobalErrorHandler } from "utils/httpClient";

// Component to handle error integration
const ErrorHandler = () => {
  const { addError } = useError();

  useEffect(() => {
    // Set the global error handler for HTTP client
    setGlobalErrorHandler((error, type, options) => {
      addError(error, type, options);
    });

    // Handle unhandled promise rejections
    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      addError(
        new Error(event.reason?.message || 'Unhandled promise rejection'),
        'APPLICATION',
        {
          showModal: true,
          showNotification: false,
          retryable: false,
          metadata: {
            type: 'unhandledRejection',
            reason: event.reason,
          },
        }
      );
    };

    // Handle global JavaScript errors
    const handleGlobalError = (event) => {
      console.error('Global JavaScript error:', event.error);
      addError(
        event.error || new Error(event.message),
        'APPLICATION',
        {
          showModal: true,
          showNotification: false,
          retryable: false,
          metadata: {
            type: 'globalError',
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
          },
        }
      );
    };

    // Add event listeners
    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    window.addEventListener('error', handleGlobalError);

    // Cleanup event listeners
    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('error', handleGlobalError);
    };
  }, [addError]);

  return null;
};

function App() {
  return (
    <ErrorProvider>
      <ErrorBoundary
        onError={(error, errorInfo) => {
          // This will be handled by the error boundary's internal logic
          console.error('Error Boundary caught error:', error, errorInfo);
        }}
      >
        <ErrorHandler />
        <GlobalErrorModal />
        <Router>
          <Routes>
            <Route path="/kabahagi/*" element={<Landing />} />
            <Route path="/kabahagi/application-form/:userData" element={<ApplicationForm />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </ErrorProvider>
  );
}

export default App;